import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const ErrorAppLoader: LoadableType<{
	entryPoint?: string;
	sessionDataError?: Error;
}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ErrorApp" */ './ErrorApp.tsx')).ErrorApp,
});
